/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2023] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetAdditionalItemsByOrderFormTypeID(orderFormTypeId) {
  const response = await $.soap({
    body: {
      GetAdditionalItemsByOrderFormTypeID: {
        $xmlns: 'http://dla.mil/ems/bpm/order/order_line_item',
        OrderFormTypeID: orderFormTypeId
      }
    },
    blueprintArrays: [
      'GetAdditionalItemsByOrderFormTypeIDResponse.Services.LU_OrderLineItem',
      'GetAdditionalItemsByOrderFormTypeIDResponse.Accessories.LU_OrderLineItem'
    ],
    blueprint: {
      additionalServices: [
        '$..Services.LU_OrderLineItem',
        {
          id: '$.ID',
          clin: '$.CLIN',
          price: '$.Price',
          model: '$.Model',
          description: '$.Description',
          chargesFrequencyId: '$.ChargesFrequencyID'
        }
      ],
      additionalAccessories: [
        '$..Accessories.LU_OrderLineItem',
        {
          id: '$.ID',
          clin: '$.CLIN',
          price: '$.Price',
          model: '$.Model',
          description: '$.Description',
          chargesFrequencyId: '$.ChargesFrequencyID'
        }
      ]
    }
  });

  _.each(response.additionalServices, (service) => {
    service.name =
      typeof service.description === 'string' || service.description instanceof String
        ? service.description
        : service.model;
    //service.name = service.name.concat(' - +$', service.price);
  });

  _.each(response.additionalAccessories, (accessories) => {
    accessories.name =
      typeof accessories.description === 'string' || accessories.description instanceof String
        ? accessories.description
        : accessories.model;
    //accessories.name = accessories.name.concat(' - +$', accessories.price);
  });
  cleanUpResponse(response);
  return response;
}
